import { Annotation } from "features/three-view/state/threeAtoms";

export const annotations: Annotation[] = [
  {
    title: 'px',
    position: {
      x: 6,
      y: 0,
      z: 0,
    },
    lookAt: {
      x: 0,
      y: 0,
      z: 0,
    },
    cameraUp: {
      x: 0,
      y: 0,
      z: 1
    },
    idx: 0,
  },
  {
    title: 'mx',
    position: {
      x: -3,
      y: 0,
      z: 0,
    },
    lookAt: {
      x: 0,
      y: 0,
      z: 0,
    },
    cameraUp: {
      x: 0,
      y: 0,
      z: 1
    },
    idx: 0,
  },
  {
    title: 'py',
    position: {
      x: 0,
      y: 4,
      z: 0,
    },
    lookAt: {
      x: 0,
      y: 0,
      z: 0,
    },
    cameraUp: {
      x: 0,
      y: 0,
      z: 1
    },
    idx: 0,
  },
  {
    title: 'my',
    position: {
      x: 0,
      y: -4,
      z: 0,
    },
    lookAt: {
      x: 0,
      y: 0,
      z: 0,
    },
    cameraUp: {
      x: 0,
      y: 0,
      z: 1
    },
    idx: 0,
  },
  {
    title: 'pz',
    position: {
      x: 0,
      y: 0,
      z: 4,
    },
    lookAt: {
      x: 0,
      y: 0,
      z: 0,
    },
    cameraUp: {
      x: 0,
      y: 1,
      z: 0
    },
    idx: 0,
  },
  {
    title: 'mz',
    position: {
      x: 0,
      y: 0,
      z: -3,
    },
    lookAt: {
      x: 0,
      y: 0,
      z: 0,
    },
    cameraUp: {
      x: 0,
      y: 1,
      z: 0
    },
    idx: 0,
  },
  {
    title: 'piso',
    position: {
      x: -2,
      y: -2,
      z: 2,
    },
    lookAt: {
      x: 0,
      y: 0,
      z: 0,
    },
    cameraUp: {
      x: 0,
      y: 0,
      z: 1
    },
    idx: 0,
  },
  {
    title: 'miso',
    position: {
      x: 3,
      y: -3,
      z: 3,
    },
    lookAt: {
      x: 0,
      y: 0,
      z: 0,
    },
    cameraUp: {
      x: 0,
      y: 0,
      z: 1
    },
    idx: 0,
  },
  {
    // Reset ボタン用。`threeAtoms.ts` の annotationState.default と同一値
    title: 'default',
    position: {
      x: 0,
      y: -3,
      z: 2,
    },
    lookAt: {
      x: 0,
      y: 0,
      z: 0,
    },
    cameraUp: {
      x: 0,
      y: 0,
      z: 1
    },
    idx: 0,
  },
];
